import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import dayjs from 'dayjs';
import _ from 'lodash';
export var Simplifier = /*#__PURE__*/function () {
  function Simplifier() {
    _classCallCheck(this, Simplifier);
  }
  _createClass(Simplifier, null, [{
    key: "submitForm",
    value: function submitForm(method, action, data) {
      // 使用 POST 方法完成页面跳转
      // > 动态构建表单
      var submitter = document.createElement('form');
      // > -
      submitter.action = action;
      submitter.method = method;
      submitter.style.display = 'none';
      // > 向表单中插入字段
      data === null || data === void 0 || data.forEach(function (element) {
        //
        var field = document.createElement('input');
        //
        field.type = 'password';
        field.name = element.name;
        field.value = element.value;
        //
        submitter.appendChild(field);
      });
      // > 提交表单
      window.document.body.appendChild(submitter);
      // > -
      submitter.submit();
    }
  }, {
    key: "findAttribute",
    value: function findAttribute(entity, key) {
      //
      var attributes = entity[Object.keys(entity).find(function (entityKey) {
        return entityKey.endsWith('Attributes');
      })];
      //
      if (attributes) {
        //
        var attribute = attributes.find(function (otherAttribute) {
          return otherAttribute.key === key;
        });
        //
        if (attribute) {
          return attribute.value;
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
  }, {
    key: "formatRetrieveRequest",
    value: function formatRetrieveRequest(params, sort, filter) {
      return {
        sort: sort,
        filter: filter,
        searcher: params.searcher,
        parameters: _.omit(params, ['searcher'])
      };
    }
  }, {
    key: "injectStatisticType",
    value: function injectStatisticType(datum, datumType) {
      if (datum) {
        return datum.map(function (data) {
          return _objectSpread(_objectSpread({}, data), {}, {
            type: datumType
          });
        });
      } else {
        return [];
      }
    }
  }, {
    key: "fillStatisticDatum",
    value: function fillStatisticDatum(datum, exceptedPeriod) {
      var exceptedKeyFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'MM-DD HH:mm';
      // -
      var datum0 = [];
      // -
      new Set(datum.map(function (data) {
        return data.type;
      })).forEach(function (type) {
        var _loop = function _loop() {
          // -
          // > -
          var dataKey = dayjs().subtract(i, 'days');
          // > -
          var data = datum.find(function (data) {
            return dayjs(data.key).isSame(dataKey, 'day') && data.type === type;
          });
          // -
          if (data) {
            datum0.push(_objectSpread(_objectSpread({}, data), {}, {
              key: dayjs(data.key)
            }));
          } else {
            datum0.push({
              type: type,
              key: dataKey,
              value: 0
            });
          }
        };
        for (var i = 0; i < exceptedPeriod; i++) {
          _loop();
        }
      });
      // -
      return datum0.toSorted(function (dataX, dataY) {
        return dataX.key.unix() - dataY.key.unix();
      }).map(function (data) {
        return _objectSpread(_objectSpread({}, data), {}, {
          key: data.key.format(exceptedKeyFormat)
        });
      });
    }
  }]);
  return Simplifier;
}();